export const GET_COURIER_PENALTIES = Symbol('GET_COURIER_PENALTIES');
export const GET_COURIER_PENALTIES_REQUEST = Symbol('GET_COURIER_PENALTIES_REQUEST');
export const GET_COURIER_PENALTIES_SUCCESS = Symbol('GET_COURIER_PENALTIES_SUCCESS');
export const GET_COURIER_PENALTIES_ERROR = Symbol('GET_COURIER_PENALTIES_ERROR');

